<template>
  <div class="system-permissions">
    <LeftRightBox :leftWidthDefault="600">
      <template slot="left">
        <SimpleTable
          ref="leftTable"
          table-code="systemPermissionsLeft"
          :menus="['查询', '批量修改']"
          :columns="columns.left"
          :data="tableData.left"
          :loading="loading.left"
          @row-select="onRowSelectLeft"
          @modify-data-change="onModifyDataChangeLeft"
        />
      </template>
      <template slot="right">
        <SimpleTable
          ref="rightTable"
          table-code="systemPermissionsRight"
          :menus="['查询', '批量修改']"
          :columns="columns.right"
          :data="tableData.right"
          :loading="loading.right"
          @modify-data-change="onModifyDataChangeRight"
        />
      </template>
    </LeftRightBox>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { sortRecords, addCbFn } from '@/utils/index'

export default {
  name: 'SystemPermissions',
  components: {
    SimpleTable,
    LeftRightBox
  },
  data() {
    return {
      // 页面数据
      columns: {
        left: [
          {
            field: 'lockNumber',
            title: '加密锁号'
          },
          {
            field: 'contactor',
            title: '联系人',
            canEdit: true,
            canModify: true
          },
          {
            field: 'contactorPhone',
            title: '联系人电话',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'contactorWx',
            title: '联系人微信',
            canEdit: true,
            canModify: true
          }
        ],
        right: [
          {
            field: 'menuName',
            title: '功能模块',
            // canEdit: true,
            // canModify: true,
            tree: true
          },
          {
            field: 'writeFlag',
            title: '维护权限',
            cellType: 'checkbox',
            multiple: true,
            canEdit: true,
            canModify: true
          },
          {
            field: 'readFlag',
            title: '只读权限',
            cellType: 'checkbox',
            multiple: true,
            canEdit: true,
            canModify: true
          },
          {
            field: 'approvalFlag',
            title: '审核权限',
            cellType: 'checkbox',
            multiple: true,
            canEdit: true,
            canModify: true
          }
          // { field: 'name', title: '生效日期', canEdit: true, canModify: true },
          // { field: 'name', title: '失效日期', canEdit: true, canModify: true }
        ]
      },
      tableData: {
        top: [],
        left: [],
        right: []
      },
      loading: {
        top: false,
        left: false,
        right: false
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTableLeft()
    },
    async getTableLeft() {
      this.tableData.left = []
      this.loading.left = true
      const res = await this.$service.get('/unit-lock/list', {})
      this.loading.left = false
      this.tableData.left = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.leftTable.initialized()
    },
    async getTableRight(obj) {
      this.tableData.right = []
      if (!obj?.id) return
      this.loading.right = true
      const res = await this.$service.get('/unit-lock-menu/list', {
        unitLockId: obj.id
      })
      this.loading.right = false
      this.tableData.right = sortRecords(res?.data || [])
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableRight(obj)
    },

    onModifyDataChangeLeft(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        '/unit-lock/batch',
        getModifyData,
        cleanModifyData
      )
    },
    onModifyDataChangeRight(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        '/unit-lock-menu/batch',
        getModifyData,
        cleanModifyData
      )
    }
  }
}
</script>

<style scoped>
.system-permissions {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
</style>
